import { RecAllocationRadioOptions, RecProgramYearRadioOptions, RecProjectCategoryRadioOptions, RecShinesProgramRadioOptions, RecUtilityGroupRadioOptions } from '~/constants';
import { WorksheetField } from '~/features/projectWizard/worksheets/common/components/Field';
import { useProjectContext } from '~/hooks';
import { DisplayRECValue } from './DisplayRECValue';
import { useDerivedRECFields } from '~/features/projectWizard/derived';

const toDropdownOptions = (opts: { value: string; label: string }[]) =>
  opts.map(o => ({ key: o.value, value: o.value, text: o.label }));

const RecAllocationDropdownOptions = toDropdownOptions(RecAllocationRadioOptions);
const RecProjectCategoryDropdownOptions = toDropdownOptions(RecProjectCategoryRadioOptions);
const RecProgramYearDropdownOptions = toDropdownOptions(RecProgramYearRadioOptions);

export default function IllinoisRECForm() {
  const { project, projectState } = useProjectContext();
  const schemaKey = (term: string) => `recsData.${project.addressState}.${term}`;
  useDerivedRECFields();

  return (
    <>
      <WorksheetField
        type="radio"
        fieldLabel="Is this part of the IL SHINES program?"
        schemaKey={schemaKey('isShinesProgram')}
        inline
        values={RecShinesProgramRadioOptions}
      />
      {projectState?.isQuote && project?.recsData?.Illinois?.isShinesProgram === 'YES' && (
        <div className="labelled-input">
          <WorksheetField
            type="number"
            schemaKey={'projectArrays.0.sizeKwac'}
            fieldLabel="Array size in kWac"
            placeholder="Enter size"
            label="kWac"
            optional={project.addressState !== 'Illinois'}
          />
        </div>
      )}
      {project?.recsData?.Illinois?.isShinesProgram === 'YES' && (
        <>
        <WorksheetField
          type="dropdown"
          fieldLabel="Have you secured a REC allocation?"
          schemaKey={schemaKey('recAllocation')}
          placeholder="Select REC allocation status"
          options={RecAllocationDropdownOptions}
        />
        <WorksheetField
          type="dropdown"
          fieldLabel="Project category"
          schemaKey={schemaKey('recProjectCategory')}
          placeholder="Select project category"
          helpText='How is this project classified within the IL SHINES program?'
          options={RecProjectCategoryDropdownOptions}
        />
        <WorksheetField
          type="radio"
          fieldLabel="Utility group"
          schemaKey={schemaKey('recUtilityGroup')}
          inline
          values={RecUtilityGroupRadioOptions}
        />
        <WorksheetField
          type="dropdown"
          fieldLabel="Program year"
          schemaKey={schemaKey('recProgramYear')}
          placeholder="Select program year"
          options={RecProgramYearDropdownOptions}
        />
        <DisplayRECValue />
      </>
      )}
    </>
  );
}